import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {DatePicker} from 'react-rainbow-components'
import moment from 'moment'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {KTSVG, initialQueryState} from '../../../../../../../../_metronic/helpers'

const ProvidenceListFilter = () => {
  const intl = useIntl()
  const {updateState} = useQueryRequest()

  //variaval de controle do filtro avançado
  const [openFilterWin, setOpenFilterWin] = useState<boolean>(false)

  //variaveis de controle de intervalo de datas
  const [openDateConclusion, setOpenDateConclusion] = useState<boolean>(false)
  const [openDateLimit, setOpenDateLimit] = useState<boolean>(false)
  const [openDateStart, setOpenDateStart] = useState<boolean>(false)

  // variaveis do filtro
  //inicio variaveis que usam AsyncSelect
  const [id, setId] = useState<string | undefined>()

  //variaveis normais
  const [description, setdescription] = useState<string | undefined>()
  const [status, setstatus] = useState<string | undefined>()

  //variaveis de Datas e intervalos de datas
  const [start_date, setstart_date] = useState<string | undefined>()
  const [start_date_between, setstart_date_between] = useState<Date | undefined>()
  const [start_date_betweenD, setstart_date_betweenD] = useState<Date | undefined>()
  const [limit_date, setlimit_date] = useState<string | undefined>()
  const [limit_date_between, setlimit_date_between] = useState<Date | undefined>()
  const [limit_date_betweenD, setlimit_date_betweenD] = useState<Date | undefined>()
  const [conclusion_date, setconclusion_date] = useState<string | undefined>()
  const [conclusion_date_between, setconclusion_date_between] = useState<Date | undefined>()
  const [conclusion_date_betweenD, setconclusion_date_betweenD] = useState<Date | undefined>()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  // função que reseta os filtros
  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})
    setId(undefined)
    setdescription(undefined)
    setstart_date(undefined)
    setstart_date_between(undefined)
    setstart_date_betweenD(undefined)
    setlimit_date(undefined)
    setlimit_date_between(undefined)
    setlimit_date_betweenD(undefined)
    setconclusion_date(undefined)
    setconclusion_date_between(undefined)
    setconclusion_date_betweenD(undefined)
    setdescription('')
    setId('')
    setstatus('')
  }

  // função que faz a busca dos dados
  const filterData = () => {
    updateState({
      filter: {
        status,
        id,
        description,
        start_date,
        start_date_between,
        limit_date,
        limit_date_between,
        conclusion_date,
        conclusion_date_between,
      },
      ...initialQueryState,
    })
  }

  // função que abre o filtro avançado
  const openFilter = () => {
    if (openFilterWin === false) {
      setOpenFilterWin(true)
    } else {
      setOpenFilterWin(false)
    }
  }

  // função que abre o filtro de data conclusão por intervalo
  const openDConclusion = () => {
    if (openDateConclusion === false) {
      setOpenDateConclusion(true)
    } else {
      setOpenDateConclusion(false)
    }
  }

  // função que abre o filtro de data limite por intervalo
  const openDLimit = () => {
    if (openDateLimit === false) {
      setOpenDateLimit(true)
    } else {
      setOpenDateLimit(false)
    }
  }

  // função que abre o filtro de data de inicio por intervalo
  const openDStart = () => {
    if (openDateStart === false) {
      setOpenDateStart(true)
    } else {
      setOpenDateStart(false)
    }
  }

  //função que Converte a data para o formato do banco de dados no componente DatePicker
  const setConvertStart_Date = (e: any) => {
    let DateFormate: any = []

    if (e.length === 2) {
      DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
      DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
    }
    setstart_date_between(DateFormate)
    setstart_date_betweenD(e)
  }

  //função que Converte a data para o formato do banco de dados no componente DatePicker
  const setConvertLimit_Date = (e: any) => {
    let DateFormate: any = []

    if (e.length === 2) {
      DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
      DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
    }
    setlimit_date_between(DateFormate)
    setlimit_date_betweenD(e)
  }

  //função que Converte a data para o formato do banco de dados no componente DatePicker
  const setConvertConclusion_Date = (e: any) => {
    let DateFormate: any = []

    if (e.length === 2) {
      DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
      DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
    }
    setconclusion_date_between(DateFormate)
    setconclusion_date_betweenD(e)
  }

  return (
    <>
      <div className='card-body p-5 pb-5 mt-3 '>
        {/* INICIO LINHA 1  FIXA DO FILTRO */}
        <div className='row'>
          <div className='col-lg-3'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'COMMON.NUMBER'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <input
                type='text'
                data-kt-license-table-filter='id'
                className='form-control form-control-solid ps-6'
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'COMMON.NUMBER'})
                }
                onChange={(e) => setId(e.target.value)}
                value={id}
              />
            </div>
          </div>

          {/* filtro de descrição */}
          <div className='col-lg-4'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <input
                type='text'
                data-kt-user-table-filter='description'
                className='form-control form-control-solid ps-6'
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'COMMON.DESCRIPTION'})
                }
                onChange={(e: any) => setdescription(e.target.value)}
                value={description}
              />
            </div>
          </div>
          {/* filtro de status  */}
          <div className='col-lg-5 mt-0'>
            <label className='form-label fs-7 fw-bold'>
              {intl.formatMessage({id: 'COMMON.STATUS'})}
            </label>
            <div className='d-flex align-items-center position-relative my-1'>
              <select
                className='form-select form-select-solid ps-6'
                data-kt-select2='true'
                data-kt-user-table-filter='status'
                onChange={(e) => setstatus(e.target.value)}
                value={status}
              >
                <option value=''>{intl.formatMessage({id: 'COMMON.ALL'})}</option>
                <option value='not_started'>
                  {intl.formatMessage({id: 'COMMON.NOT_STARTED'})}
                </option>
                <option value='in_progress'>
                  {intl.formatMessage({id: 'COMMON.IN_PROGRESS'})}
                </option>
                <option value='expired'>{intl.formatMessage({id: 'COMMON.EXPIRED'})}</option>
                <option value='canceled'>{intl.formatMessage({id: 'COMMON.CANCELED'})}</option>
                <option value='done'>{intl.formatMessage({id: 'COMMON.COMPLETED'})}</option>
              </select>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-primary btn-active-primary p-3 m-1'
                onClick={openFilter}
                title='Mais Filtros'
              >
                <i className='bi bi-sliders2-vertical fs-2' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-danger p-3 m-1'
                onClick={resetData}
                title='Limpar Busca'
              >
                <KTSVG path='/media/icons/duotune/art/art004.svg' className='svg-icon-3' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-primary m-1'
                onClick={filterData}
                title='Filtar'
              >
                {intl.formatMessage({id: 'COMMON.SEARCH'})}
              </button>
            </div>
          </div>
        </div>

        {/*sINICIO LINHA 2 */}
        {openFilterWin && (
          <div className='row mt-2'>
            {/* inicio filtro de data de inicio   */}
            {/* data simples  */}
            {openDateStart === false && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.START_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='date'
                    data-kt-user-table-filter='start_date'
                    className='form-control form-control-solid  ps-6'
                    onChange={(e: any) => setstart_date(e.target.value)}
                    value={start_date}
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDStart}
                    title='selecionar intervalo'
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* data intervalo */}
            {openDateStart === true && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.START_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <DatePicker
                    data-kt-user-table-filter='start_date_between'
                    className=' border border-0 rounded-0'
                    placeholder={intl.formatMessage({id: 'CONDITIONINGS.START_DATE_SELECT'})}
                    onChange={(e) => setConvertStart_Date(e)}
                    selectionType='range'
                    formatStyle='small'
                    variant='single'
                    value={start_date_betweenD}
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDStart}
                    title={intl.formatMessage({id: 'CONDITIONINGS.SELECT_INTERVAL'})}
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* fim filtro de data de inicio   */}

            {/* inicio filtro de data de conclusão */}
            {/* data simples  */}
            {openDateConclusion === false && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='date'
                    data-kt-user-table-filter='conclusion_date'
                    className='form-control form-control-solid ps-6'
                    onChange={(e) => setconclusion_date(e.target.value)}
                    value={conclusion_date}
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDConclusion}
                    title={intl.formatMessage({id: 'CONDITIONINGS.SELECT_INTERVAL'})}
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* data intervalo */}
            {openDateConclusion === true && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <DatePicker
                    data-kt-user-table-filter='conclusion_date_between'
                    className=' border border-0 '
                    placeholder={intl.formatMessage({id: 'CONDITIONINGS.CONCLUSION_DATE_SELECT'})}
                    onChange={(e) => setConvertConclusion_Date(e)}
                    selectionType='range'
                    formatStyle='large'
                    variant='single'
                    value={conclusion_date_betweenD}
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDConclusion}
                    title={intl.formatMessage({id: 'CONDITIONINGS.SELECT_INTERVAL'})}
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* inicio filtro de data de limite   */}
            {/* data simples  */}
            {openDateLimit === false && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.LIMIT_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='date'
                    data-kt-user-table-filter='limit_date'
                    className='form-control form-control-solid  ps-6'
                    onChange={(e: any) => setlimit_date(e.target.value)}
                    value={limit_date}
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDLimit}
                    title='selecionar intervalo'
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* data intervalo */}
            {openDateLimit === true && (
              <div className='col-lg-4'>
                <label className='form-label fs-7 fw-bold'>
                  {intl.formatMessage({id: 'COMMON.LIMIT_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <DatePicker
                    data-kt-user-table-filter='limit_date_between'
                    className=' border border-0 rounded-0'
                    placeholder={intl.formatMessage({id: 'CONDITIONINGS.LIMIT_DATE_SELECT'})}
                    onChange={(e) => setConvertLimit_Date(e)}
                    selectionType='range'
                    formatStyle='large'
                    variant='single'
                    value={limit_date_betweenD}
                  />
                  <button
                    type='button'
                    className='btn btn-sm btn-icon btn-primary m-1'
                    onClick={openDLimit}
                    title={intl.formatMessage({id: 'CONDITIONINGS.SELECT_INTERVAL'})}
                  >
                    <KTSVG
                      path='/media/icons/duotune//general/gen019.svg'
                      className='svg-icon-2 svg-icon-light'
                    />
                  </button>
                </div>
              </div>
            )}
            {/* fim filtro de data de limite */}
          </div>
        )}
        {/* fim filtro de data */}
        {/* FIM LINHA 2 */}
      </div>
    </>
  )
}

export {ProvidenceListFilter}
